import { noop } from 'lodash-es';

import { appConfig } from '@ll-platform/frontend/config/app.config';
import { extractDomainFromEmail } from '@ll-platform/frontend/utils/helpers/helpers';

// Use this function on endpoints which are shared between public and private pages
// We still want to include auth for analytics and tracking, but we ignore missing session
// In the future, we can add conditional logic here
export function ignoreUnauthorizedOnSharedEndpoint() {
  return noop();
}

export function isSecureEmailDomain(email: string) {
  return appConfig.REACT_APP_SECURE_EMAIL_DOMAINS.includes(
    extractDomainFromEmail(email),
  );
}
